// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header-badge[data-v-25244ffb]{color:var(--header-color);display:inline-flex;flex-direction:column;height:60px;justify-content:space-between;padding:0 15px;text-align:center}.header-badge[data-v-25244ffb]:last-of-type{padding-right:0}.header-badge .header[data-v-25244ffb]{font-size:12px;margin-bottom:2px;opacity:1;text-transform:uppercase;white-space:nowrap}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
